export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./BasicMixin.vue?vue&type=template&id=1eb9add4&"


//////////////////
// WEBPACK FOOTER
// ./src/components/shared/mixins/BasicMixin.vue?vue&type=template&id=1eb9add4&
// module id = null
// module chunks = 